export const navLinks = [
  { label: '今日热度榜', href: '#hot' },
  { label: '最新爆料', href: '#latest' },
  { label: '深挖专区', href: '#zones' },
  { label: '私聊曝光', href: '#chat' },
  { label: '深度追踪', href: '#track' },
];

export const tickerWords = [
  '签约内幕',
  '公司压榨',
  '潜规则',
  '私聊记录',
  '行业黑幕',
  '违约金条款',
  '资源位争夺',
  '账号归属',
  '天价培养费',
  '比例分成',
];

export const heroStats = [
  { value: '4,502', label: '累计爆料线索' },
  { value: '128', label: '已追踪公司' },
  { value: '36', label: '深度专题' },
  { value: '92%', label: '线索核实率' },
];

export const hotRanking = [
  {
    rank: 1,
    title: '某头部 MCN 签约合同流出：六年长约暗藏千万违约金条款',
    tag: '签约内幕',
    heat: '98.6万',
    trend: 'up',
  },
  {
    rank: 2,
    title: '直播公司月度考核表曝光：未达标主播被扣光全部底薪',
    tag: '公司压榨',
    heat: '76.2万',
    trend: 'up',
  },
  {
    rank: 3,
    title: '深夜私聊记录流出：经纪人被指安排「陪局」换取资源位',
    tag: '潜规则',
    heat: '63.9万',
    trend: 'down',
  },
  {
    rank: 4,
    title: '带货账号突然停更背后：账号归属权之争进入仲裁程序',
    tag: '行业黑幕',
    heat: '51.4万',
    trend: 'up',
  },
  {
    rank: 5,
    title: '新人培养费天价账单曝光：培训、妆造、流量全算在主播头上',
    tag: '公司压榨',
    heat: '44.7万',
    trend: 'down',
  },
];

export const latestScoops = [
  {
    id: 'scoop-1',
    category: '签约内幕',
    title: '一份被藏了三年的补充协议',
    summary:
      '爆料人称签约当天只看到主合同，直到提出解约才第一次见到补充协议，其中的分成比例与当初口头承诺完全相反。',
    time: '2 小时前',
    views: '12.4万',
    cover:
      'https://readdy.ai/api/search-image?query=A%20close%20up%20of%20a%20confidential%20contract%20document%20on%20a%20dark%20wooden%20desk%20with%20a%20fountain%20pen%20and%20a%20red%20wax%20seal%2C%20warm%20dramatic%20lighting%2C%20shallow%20depth%20of%20field%2C%20editorial%20photography%2C%20muted%20charcoal%20and%20amber%20tones%2C%20mysterious%20atmosphere&width=800&height=560&seq=nhbl-cover-01&orientation=landscape',
  },
  {
    id: 'scoop-2',
    category: '公司压榨',
    title: '连续直播 42 天：排班表上的「休息日」',
    summary:
      '流出的排班表显示，所谓休息日仍需到公司待命，主播被要求随叫随到，缺席一次按旷工三倍扣款，申诉渠道形同虚设。',
    time: '5 小时前',
    views: '9.8万',
    cover:
      'https://readdy.ai/api/search-image?query=A%20young%20performer%20sitting%20alone%20backstage%20under%20a%20single%20harsh%20spotlight%2C%20dark%20empty%20studio%20in%20the%20background%2C%20dramatic%20contrast%2C%20editorial%20documentary%20photography%2C%20warm%20amber%20light%20against%20deep%20shadow%2C%20tense%20mood&width=800&height=560&seq=nhbl-cover-02&orientation=landscape',
  },
  {
    id: 'scoop-3',
    category: '私聊记录',
    title: '三张聊天截图里的资源交换',
    summary:
      '对话中出现多个模糊代号，爆料人表示这些代号对应固定的商务资源位，普通新人几乎不可能拿到，交换条件被刻意省略。',
    time: '昨天',
    views: '15.6万',
    cover:
      'https://readdy.ai/api/search-image?query=A%20smartphone%20lying%20on%20a%20dark%20textured%20surface%20with%20glowing%20blurred%20chat%20bubbles%20on%20screen%2C%20dramatic%20low%20key%20lighting%2C%20warm%20amber%20glow%20reflecting%20on%20the%20glass%2C%20editorial%20tech%20photography%2C%20moody%20secretive%20atmosphere&width=800&height=560&seq=nhbl-cover-03&orientation=landscape',
  },
  {
    id: 'scoop-4',
    category: '潜规则',
    title: '面试间里的「第二场谈话」',
    summary:
      '多名受访者提到初面通过后会被单独约见，谈话内容与业务无关，相关时间、地点与在场人员已被整理成可交叉验证的时间线。',
    time: '昨天',
    views: '7.2万',
    cover:
      'https://readdy.ai/api/search-image?query=An%20empty%20audition%20room%20with%20a%20single%20chair%20under%20a%20narrow%20spotlight%2C%20dark%20walls%20and%20deep%20shadows%2C%20dramatic%20cinematic%20lighting%20in%20warm%20amber%20tones%2C%20editorial%20photography%2C%20quiet%20uneasy%20atmosphere&width=800&height=560&seq=nhbl-cover-04&orientation=landscape',
  },
];

export const digZones = [
  {
    key: 'contract',
    name: '签约内幕',
    count: 1286,
    desc: '合同版本、违约金、续约条款与口头承诺之间的落差，逐条对照。',
    icon: 'ri-file-paper-2-line',
    cover:
      'https://readdy.ai/api/search-image?query=A%20stack%20of%20signed%20contracts%20and%20stamped%20documents%20on%20a%20dark%20desk%20with%20a%20pen%20and%20reading%20glasses%2C%20warm%20side%20lighting%2C%20editorial%20close%20up%20photography%2C%20charcoal%20and%20amber%20tones&width=600&height=420&seq=nhbl-zone-01&orientation=landscape',
  },
  {
    key: 'squeeze',
    name: '公司压榨',
    count: 964,
    desc: '排班、考核、罚款与「自愿加班」背后的账本，还原真实工作强度。',
    icon: 'ri-time-line',
    cover:
      'https://readdy.ai/api/search-image?query=A%20dim%20late%20night%20office%20with%20empty%20desks%20and%20piles%20of%20paperwork%2C%20single%20warm%20desk%20lamp%20glowing%2C%20dramatic%20shadows%2C%20editorial%20photography%2C%20oppressive%20atmosphere&width=600&height=420&seq=nhbl-zone-02&orientation=landscape',
  },
  {
    key: 'rules',
    name: '潜规则',
    count: 742,
    desc: '被模糊处理的饭局、资源位与「圈内默认规则」，逐一标注来源。',
    icon: 'ri-eye-off-line',
    cover:
      'https://readdy.ai/api/search-image?query=A%20closed%20door%20in%20a%20dim%20corridor%20with%20warm%20light%20spilling%20from%20underneath%2C%20dramatic%20shadows%20and%20low%20key%20lighting%2C%20editorial%20photography%2C%20secretive%20tense%20mood&width=600&height=420&seq=nhbl-zone-03&orientation=landscape',
  },
  {
    key: 'chat',
    name: '私聊记录',
    count: 1510,
    desc: '聊天截图、语音转文字与关键对话的逐条比对，标注时间戳。',
    icon: 'ri-chat-3-line',
    cover:
      'https://readdy.ai/api/search-image?query=A%20close%20up%20of%20handwritten%20notes%20and%20a%20phone%20beside%20them%20showing%20blurred%20messages%2C%20dark%20table%2C%20warm%20lamp%20light%2C%20editorial%20photography%2C%20investigative%20secretive%20atmosphere&width=600&height=420&seq=nhbl-zone-04&orientation=landscape',
  },
];

export const chatThread = [
  { side: 'them', text: '资料我看过了，条件可以谈，但有件事先说清楚。', time: '23:41' },
  { side: 'me', text: '您说，我这边都有记录。', time: '23:42' },
  {
    side: 'them',
    text: '分成按七三，你三。这件事别写进聊天记录，见面聊。',
    time: '23:44',
    flag: true,
  },
  { side: 'me', text: '可之前谈的明明是五五……', time: '23:45' },
  {
    side: 'them',
    text: '那是意向，合同以最终版为准。要签就今天定，过了今天资源位给别人。',
    time: '23:47',
    flag: true,
  },
];

export const chatHighlights = [
  {
    name: '截图 01 · 资源位交换',
    time: '2024.11.23 23:44',
    note: '出现 3 个模糊代号，对应固定商务资源位，交换条件被刻意省略。',
  },
  {
    name: '截图 04 · 违约金改口',
    time: '2024.12.06 19:12',
    note: '口头承诺「随时可解约」，同日发送的合同附件却写明 800 万违约金。',
  },
  {
    name: '截图 09 · 账号归属',
    time: '2025.01.18 02:07',
    note: '明确要求主播将账号绑定公司主体，并删除此前所有独立运营记录。',
  },
];

export const deepTrack = [
  {
    date: '3 月 02 日',
    title: '线索汇入',
    desc: '收到 27 位前员工的匿名投稿，内容指向同一家 MCN 机构的用工方式。',
  },
  {
    date: '3 月 11 日',
    title: '文件比对',
    desc: '将两版合同逐条比对，确认分成比例与违约金条款被单方面修改。',
  },
  {
    date: '3 月 26 日',
    title: '当事人回应',
    desc: '公司以「商业机密」为由拒绝置评，主播一方首度公开说明情况。',
  },
  {
    date: '4 月 09 日',
    title: '追踪更新',
    desc: '新增排班表与考核记录，关于公司压榨的证据链进一步完善。',
  },
];

export const clueTypes = [
  { icon: 'ri-image-2-line', name: '图文线索', desc: '合同、账单、排班表等文件照片' },
  { icon: 'ri-vidicon-line', name: '视频线索', desc: '现场录音、录屏与关键片段' },
  { icon: 'ri-chat-voice-line', name: '私聊截图', desc: '聊天记录、语音转文字与时间戳' },
];

export const footerColumns = [
  {
    title: '内容分区',
    links: ['今日热度榜', '最新爆料', '签约内幕', '公司压榨', '潜规则', '私聊记录'],
  },
  {
    title: '关于本站',
    links: ['爆料流程说明', '线索核实标准', '隐私保护承诺', '更正与申诉', '联系我们'],
  },
  {
    title: '使用须知',
    links: ['免责声明', '内容版权说明', '举报不良信息', '未成年人保护', '意见反馈'],
  },
];